import { Component, ViewChild } from '@angular/core';
import { NgbDropdownModule, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { TaxSubSectionFormComponent } from '../tax-sub-section-form/tax-sub-section-form.component';
import { CommonModule } from '@angular/common';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-tax-sub-section',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, NgSelectModule, NgbDropdownModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './tax-sub-section.component.html',
  styleUrl: './tax-sub-section.component.scss'
})
export class TaxSubSectionComponent {
  isDisabled: boolean = false;
  //IncomeHeads = [] as any;
  IncomeHeads = [] as any;
  Regimes = [{ Name: 'All', value: '' }, { Name: 'Old Regime', value: false }, { Name: 'New Regime', value: true }]
  TableDatas: any[] = [];
  FinancialYears: any[] = [];

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    SelectType: 'S',
    ESS_TaxSectionDetailID: 0,
    ESS_TaxSectionMasterID: 0,
    // YearStart: null as any,
    // YearEnd: null as any,
    FinancialYearFrom: '' as any,
    FinancialYearTo: '' as any,
    IncomeHead: null,
    IsNewRegime: null,
    Regime: '',
    ESS_TaxFinancialYearID: null,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private incometax: IncometaxService,
    protected dateFormat: CustomDateParserFormatter,
    private download: DownloadSampleService
    //private combo: ComboService,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    //this.ComboLoad('IncomeTaxHead');
    this.ESS_TaxFinancialYearSelect();
    this.TaxSectionDetail_SelectLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table;
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });
        } else {
          this.FinancialYears = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  TaxSectionDetail_SelectLoad() {
    this.isDisabled = true;
    // if (this.Filter.YearStart == null || this.Filter.YearStart.toString().length != 4 || this.Filter.YearStart <= 0) {
    //   //this.toast.show({ message: "Please enter financial year start year", type: toastTypeEnum.danger });
    //   this.Filter.FinancialYearFrom = null;
    //   this.Filter.FinancialYearTo = null;
    // } 
    if (this.Filter.ESS_TaxFinancialYearID == null || this.Filter.ESS_TaxFinancialYearID == 0) {
      this.Filter.FinancialYearFrom = null;
      this.Filter.FinancialYearTo = null;
    } else {
      //this.Filter.YearEnd = parseInt(this.Filter.YearStart) + 1;
      // this.Filter.FinancialYearFrom = "01 APR " + this.Filter.YearStart.toString();
      // this.Filter.FinancialYearTo = "31 MAR " + this.Filter.YearEnd.toString();

      this.Filter.FinancialYearFrom = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear() });
      this.Filter.FinancialYearTo = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear() });
    }
    this.incometax.TaxSectionDetail_SelectLoad(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = [];
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addTaxSubSection(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(TaxSubSectionFormComponent, {
        size: 'lg',
        backdrop: 'static',
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.ID = ID;
      modalRef.result.then(
        (result: any) => {
          if (result) {
            this.TaxSectionDetail_SelectLoad();
          }
        },
        () => { }
      );
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  // ComboLoad(Combotype: String) {
  //   this.isDisabled = true;
  //   this.combo.ComboLoad({ 'Combotype': Combotype }).subscribe({
  //     next: (response) => {
  //       if (Combotype == 'IncomeTaxHead') {
  //         this.IncomeHeads = response.ComboLoad;
  //       }
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  // SetFinancialYearEnd() {
  //   if (this.Filter.YearStart != null && this.Filter.YearStart.toString().length == 4 && this.Filter.YearStart > 0) {
  //     this.Filter.YearEnd = parseInt(this.Filter.YearStart) + 1;
  //   } else {
  //     this.Filter.YearEnd = null
  //   }
  // }

  getFinancialYearDisplay(startDate: string, endDate: string): string {
    if (!startDate || !endDate) return '';

    try {
      const startYear = new Date(startDate).getFullYear();
      const endYear = new Date(endDate).getFullYear();
      return `${startYear}-${endYear}`;
    } catch (error) {
      console.error('Error parsing dates:', error);
      return '';
    }
  }

  clear() {
    this.TableDatas = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }

  ExcelDump() {
    if (this.TableDatas.length == 0) {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    } else {
      this.download.exportToExcelWithProgress(this.TableDatas, 'Tax Sub Section Master');
    }
  }
}
